/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { React, useContext, useEffect, useState } from 'react'
import App from '../../layout/App';
import {
    FormContent, Container, Box,
    Select, Option,
    TitleFieldForm, Message, Madatory,
    Box3Items
} from '../../styles/styles'
import Checkbox from '../../Components/checkbox'
import { useNavigate } from 'react-router-dom';
import '../../styles/styles.css';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import api from '../../utils/api';
import { ClearMask } from '../../utils/mask';
import Loading from '../../Components/Loading';
import MessagePopUp from '../../Components/messagePopUp';
import { IsNone } from '../../utils/functions';
import InfoForm from '../../Components/infoForm';
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { escolaJson } from '../../utils/objectJson';
import { validationForm3 } from '../../utils/validationSchool';
import { useIndexedLabels } from '../../utils/useIndexedLabels';






function Organizacao() {
    const {
        getTitleIndex,
        getIndexByLabel,
    } = useIndexedLabels();
    const [messageRequired, setMessageRequired] = useState([])
    const navigation = useNavigate()
    const [removeLoad, setRemoveLoad] = useState(false)
    const [OrganizacaoEscola, setOrganizacaoEscola] = useState(escolaJson)
    const [listAux1, setListAux1] = useState([])
    const [listAux2, setListAux2] = useState([])
    const { setErrorMessage } = useContext(MessageContext);
    const [listCodeIndiginas, setListCodeIndiginas] = useState([])


    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationForm3)
    });

    const onSubmit = async (data) => {
        setRemoveLoad(false)
        let dados = OrganizacaoEscola
        if (dados.telephone?.mainPhone) {
            dados.telephone.mainPhone = ClearMask(dados.telephone?.mainPhone ?? "")
            dados.telephone.secondaryPhone = ClearMask(dados.telephone?.secondaryPhone ?? "")
        }
        dados.address.cep = ClearMask(dados.address?.cep)
        dados.wasChanged = dados.wasChanged = true
        await api.put('/school/', dados).then((response) => {
            setRemoveLoad(true)
            setErrorMessage([{ message: "Escola atualizada com sucesso!", ok: true }])
            // sessionStorage.removeItem('EscolaEditar')
            navigation('/home', { replace: true })

        }).catch(errors => {
            setRemoveLoad(true)
            setErrorMessage([{ message: "Erro ao atualizar escola!", ok: false }])

        })

        // O valor é representado em milisegundos.
    };

    useEffect(() => {
        setRemoveLoad(true)
        let escola = JSON.parse(sessionStorage.getItem('EscolaEditar'));
        setOrganizacaoEscola(escola)
        api.get('/resource/indigenous-language/list').then((response) => {
            setListCodeIndiginas(response.data)
            setListAux1(response.data)
            setListAux2(response.data)
        }).catch((error) => {
            setErrorMessage([{ message: "erro ao buscar dados auxiliares", ok: false }])
        })
    }, [])

    useEffect(() => {
        //criar uma function
        let Filt = []
        let Filt1 = []
        Filt = listCodeIndiginas.filter((item) => {
            if (item.code !== OrganizacaoEscola.indigenousLanguageCodes?.code1) {
                return item
            }
        })
        Filt1 = listCodeIndiginas.filter((item) => {
            if (item.code !== OrganizacaoEscola.indigenousLanguageCodes?.code1 && item.code !== OrganizacaoEscola.indigenousLanguageCodes?.code2) {
                return item
            }
        })

        setListAux1(Filt)
        setListAux2(Filt1)

    }, [OrganizacaoEscola.indigenousLanguageCodes, listCodeIndiginas])


    useEffect(() => {
        if (errors) {
            const entries = Object.entries(errors).map(([key, error]) => ({
                id: key + '-' + error.message,
                fieldName: key,
                error,
            }));
            setMessageRequired(entries);
        }
    }, [errors]);


    console.log('validations:', errors)

    return (
        <>
            {!removeLoad && <Loading />}
            <div className='span-message'>
                {messageRequired.map(({ id, fieldName, error }) => {
                    const idx = getIndexByLabel(fieldName) || "";
                    const text = error.message;

                    return (
                        <MessagePopUp
                            key={id}
                            title={`Campo ${idx} - obrigatório`}
                            text={text}
                            onClose={() =>
                                setMessageRequired(prev => prev.filter(m => m.id !== id))
                            }
                        />
                    );
                })}
            </div>
            <App>
                <Container>
                    <InfoForm
                        title={'Escola'}
                        wasChanged={OrganizacaoEscola.wasChanged}
                        positionPagination={'3/3'}
                        subtitle={'Organização'}
                    />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <FormContent>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Instrumentos e materiais socioculturais e/ou pedagógicos em uso na escola para o desenvolvimento de atividades de ensino-aprendizagem ','learningInstrumentsMaterial')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Checkbox title='Acervo multimídia'
                                    name='learningInstrumentsMaterial[0]'
                                    setValue={setValue('learningInstrumentsMaterial[0]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.multimediaCollection)}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.multimediaCollection === 1 ? true : false}
                                    register={register('learningInstrumentsMaterial[0]')}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                multimediaCollection: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Brinquedos para educação infantil'
                                    name='learningInstrumentsMaterial[1]'
                                    setValue={setValue('learningInstrumentsMaterial[1]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.childrenEducationToys)}
                                    register={register('equipmentResource.learningInstrumentsMaterial[1]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.childrenEducationToys === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                childrenEducationToys: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Conjunto de materiais científicos'
                                    name='learningInstrumentsMaterial[2]'
                                    setValue={setValue('learningInstrumentsMaterial[2]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.scientificSet)}
                                    register={register('learningInstrumentsMaterial[2]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.scientificSet === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                scientificSet: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Equipamento para amplificação e difusão de som/áudio'
                                    name='learningInstrumentsMaterial[3]'
                                    setValue={setValue('learningInstrumentsMaterial[3]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.soundAmplificationBroadcastingEquipment)}
                                    register={register('learningInstrumentsMaterial[3]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.soundAmplificationBroadcastingEquipment === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                soundAmplificationBroadcastingEquipment: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Instrumentos musicais para conjunto, banda/fanfarra e/ou aulas de músicas'
                                    name='learningInstrumentsMaterial[4]'
                                    setValue={setValue('learningInstrumentsMaterial[4]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.instrumentsBandsMusicClass)}
                                    register={register('learningInstrumentsMaterial[4]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.instrumentsBandsMusicClass === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                instrumentsBandsMusicClass: e.target.checked ? 1 : 0,
                                                noneLIM: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Jogos educativos'
                                    name='learningInstrumentsMaterial[5]'
                                    setValue={setValue('learningInstrumentsMaterial[5]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.educationalGames)}
                                    register={register('learningInstrumentsMaterial[5]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.educationalGames === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                educationalGames: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Matériais para atividades culturais e artísticas'
                                    name='learningInstrumentsMaterial[6]'
                                    setValue={setValue('learningInstrumentsMaterial[6]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.artisticCulturalActivities)}
                                    register={register('learningInstrumentsMaterial[6]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.artisticCulturalActivities === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                artisticCulturalActivities: e.target.checked ? 1 : 0,
                                                noneLIM: 0
                                            }
                                        }
                                    })} />
                                <Checkbox title='Matériais para educação profissional'
                                    name='learningInstrumentsMaterial[7]'
                                    setValue={setValue('learningInstrumentsMaterial[7]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.professionalEducation)}
                                    register={register('learningInstrumentsMaterial[7]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.professionalEducation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                professionalEducation: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Matériais para prática desportivas e recreação'
                                    name='learningInstrumentsMaterial[8]'
                                    setValue={setValue('learningInstrumentsMaterial[8]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.sportRecreation)}
                                    register={register('learningInstrumentsMaterial[8]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.sportRecreation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                sportRecreation: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Matériais pedagógicos para a educação das relações étnicos'
                                    name='learningInstrumentsMaterial[9]'
                                    setValue={setValue('learningInstrumentsMaterial[9]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.racialEthnicRelations)}
                                    register={register('learningInstrumentsMaterial[9]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.racialEthnicRelations === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                racialEthnicRelations: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Matériais pedagógicos para a educação escolar indígena'
                                    name='learningInstrumentsMaterial[10]'
                                    setValue={setValue('learningInstrumentsMaterial[10]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.indigenousSchoolEducation)}
                                    register={register('learningInstrumentsMaterial[10]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.indigenousSchoolEducation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                indigenousSchoolEducation: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Matériais pedagógicos para a educação do campo'
                                    name='learningInstrumentsMaterial[11]'
                                    setValue={setValue('learningInstrumentsMaterial[11]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.fieldEducation)}
                                    register={register('learningInstrumentsMaterial[11]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.fieldEducation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                fieldEducation: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Materiais pedagógicos para a educação bilíngue de surdos'
                                    name='learningInstrumentsMaterial[12]'
                                    setValue={setValue('learningInstrumentsMaterial[12]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.pedagogicalMaterialsBilingualDeaf)}
                                    register={register('learningInstrumentsMaterial[12]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.pedagogicalMaterialsBilingualDeaf === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                pedagogicalMaterialsBilingualDeaf: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Equipamentos e instrumentos para atividades em área de horta, plantio e/ou produção agrícola'
                                    name='learningInstrumentsMaterial[13]'
                                    setValue={setValue('learningInstrumentsMaterial[13]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.agricultureEquipment)}
                                    register={register('learningInstrumentsMaterial[13]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.agricultureEquipment === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                agricultureEquipment: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Materiais pedagógicos para a educação escolar quilombola'
                                    name='learningInstrumentsMaterial[14]'
                                    setValue={setValue('learningInstrumentsMaterial[14]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.quilombolaEducation)}
                                    register={register('learningInstrumentsMaterial[14]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.quilombolaEducation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                quilombolaEducation: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Materiais pedagógicos para a educação especial'
                                    name='learningInstrumentsMaterial[15]'
                                    setValue={setValue('learningInstrumentsMaterial[15]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.specialEducation)}
                                    register={register('learningInstrumentsMaterial[15]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.specialEducation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial: {
                                                ...OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial,
                                                specialEducation: e.target.checked ? 1 : 0,
                                                noneLIM: 0

                                            }
                                        }
                                    })} />
                                <Checkbox title='Nenhum dos instrumentos listados'
                                    name='learningInstrumentsMaterial[16]'
                                    setValue={setValue('learningInstrumentsMaterial[16]', OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.noneLIM)}
                                    register={register('learningInstrumentsMaterial[16]')}
                                    checked={OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial.noneLIM === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, equipmentResource: {
                                            ...OrganizacaoEscola.equipmentResource, learningInstrumentsMaterial:
                                                IsNone(OrganizacaoEscola.equipmentResource.learningInstrumentsMaterial, 'noneLIM')
                                        }
                                    })} />
                                <Message>{errors.learningInstrumentsMaterial?.message}</Message>
                            </Box>

                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                 {getTitleIndex('Escola indígena', 'indigenousSchool')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Select
                                    {...setValue('indigenousSchool', OrganizacaoEscola.indigenousSchool ?? -1)}
                                    name='indigenousSchool'
                                    {...register('indigenousSchool')}
                                    value={OrganizacaoEscola.indigenousSchool ?? -1}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, indigenousSchool: Number(e.target.value) })}>
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.indigenousSchool?.message}</Message>
                            </Box>
                            <Box style={{ display: OrganizacaoEscola.indigenousSchool === 1 ? 'flex' : 'none' }}>
                                <TitleFieldForm>
                                    {getTitleIndex('língua em que o ensino é ministrado', 'languageTeaching', OrganizacaoEscola.indigenousSchool === 1)}
                                </TitleFieldForm>
                                <Checkbox id='ID' title='Língua Indígena'
                                    name='languageTeaching[0]'
                                    setValue={setValue('languageTeaching[0]', OrganizacaoEscola.languageTeaching.indigenousLanguage) === 1 ? 'ID' : 0}
                                    value="ID"
                                    register={register('languageTeaching[0]')}
                                    disabled={Number(OrganizacaoEscola.indigenousSchool) === 1 ? false : true}
                                    checked={OrganizacaoEscola.languageTeaching.indigenousLanguage === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, languageTeaching: {
                                            ...OrganizacaoEscola.languageTeaching,
                                            indigenousLanguage: e.target.checked ? 1 : 0,
                                            portugueseLanguage: 0,
                                        }
                                    })} />
                                <Checkbox id="PT" title='Língua Portuguesa'
                                    name='languageTeaching[1]'
                                    setValue={setValue('languageTeaching[1]', OrganizacaoEscola.languageTeaching.portugueseLanguage === 1 ? 'PT' : 0)}
                                    register={register('languageTeaching[1]')}
                                    value='2'
                                    disabled={Number(OrganizacaoEscola.indigenousSchool) === 1 ? false : true}
                                    checked={OrganizacaoEscola.languageTeaching.portugueseLanguage === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, languageTeaching: {
                                            ...OrganizacaoEscola.languageTeaching,
                                            indigenousLanguage: 0,
                                            portugueseLanguage: e.target.checked ? 1 : 0

                                        }
                                    })} />
                                <Message>{errors.languageTeaching?.message}</Message>
                            </Box>
                            {/*falta dois campos para cod indigena*/}
                            <Box3Items style={{ marginTop: 10, display: OrganizacaoEscola.languageTeaching.indigenousLanguage === 1 ? null : 'none' }}>
                                <Box style={{ marginRight: 10 }}>
                                    <TitleFieldForm>1 - Língua Indígena</TitleFieldForm>
                                    <Select
                                        name='indigenousLanguageCode[0]'
                                        style={{ marginRight: 10 }}
                                        register={register('indigenousLanguageCode[0]')}
                                        {...setValue('indigenousLanguageCode[0]', OrganizacaoEscola.indigenousLanguageCodes?.code1 ?? 0)}
                                        value={OrganizacaoEscola.indigenousLanguageCodes?.code1}
                                        disabled={Number(OrganizacaoEscola.languageTeaching.indigenousLanguage) === 1 ? false : true}
                                        onChange={(e) => setOrganizacaoEscola({
                                            ...OrganizacaoEscola, indigenousLanguageCodes: {
                                                ...OrganizacaoEscola.indigenousLanguageCodes,
                                                code1: Number(e.target.value)
                                            }
                                        })}>
                                        <option value={0} selected disabled>selecione</option>
                                        {
                                            listCodeIndiginas.map((item, index) => {
                                                return <option key={index} value={item.code} >{item.name}</option>
                                            })
                                        }
                                    </Select>
                                </Box>
                                <Box style={{ marginRight: 10 }}>
                                    <TitleFieldForm>2 - Língua Indígena</TitleFieldForm>
                                    <Select
                                        name='indigenousLanguageCode[1]'
                                        register={register('indigenousLanguageCode[1]')}
                                        {...setValue('indigenousLanguageCode[1]', OrganizacaoEscola.indigenousLanguageCodes?.code2 ?? 0)}
                                        value={OrganizacaoEscola.indigenousLanguageCodes?.code2}
                                        disabled={Number(OrganizacaoEscola.languageTeaching.indigenousLanguage) === 1 ? false : true}
                                        onChange={(e) => setOrganizacaoEscola({
                                            ...OrganizacaoEscola, indigenousLanguageCodes: {
                                                ...OrganizacaoEscola.indigenousLanguageCodes,
                                                code2: Number(e.target.value)
                                            }
                                        })}>
                                        <option value={0} selected disabled>selecione</option>
                                        {
                                            listAux1.map((item, index) => {
                                                return <option key={index} value={item.code} >{item.name}</option>
                                            })
                                        }
                                    </Select>
                                </Box>
                                <Box>
                                    <TitleFieldForm>3 - Língua Indígena</TitleFieldForm>
                                    <Select
                                        name='indigenousLanguageCode[2]'
                                        register={register('indigenousLanguageCode[2]')}
                                        {...setValue('indigenousLanguageCode[2]', OrganizacaoEscola.indigenousLanguageCodes?.code3 ?? 0)}
                                        value={OrganizacaoEscola.indigenousLanguageCodes?.code3}
                                        disabled={Number(OrganizacaoEscola.languageTeaching.indigenousLanguage) === 1 ? false : true}
                                        onChange={(e) => setOrganizacaoEscola({
                                            ...OrganizacaoEscola, indigenousLanguageCodes: {
                                                ...OrganizacaoEscola.indigenousLanguageCodes,
                                                code3: Number(e.target.value)
                                            }
                                        })}>
                                        <option value={0} selected disabled>selecione</option>
                                        {
                                            listAux2.map((item, index) => {
                                                return <option key={index} value={item.code} >{item.name}</option>
                                            })
                                        }
                                    </Select>
                                </Box>
                                <Message>{errors.indigenousLanguageCode?.message}</Message>
                            </Box3Items>

                            <Box>
                                <TitleFieldForm>
                                    {getTitleIndex('A escola faz exame de seleção para ingresso de seus alunos','haveSelectionExam')}
                                </TitleFieldForm>
                                <Select

                                    name='haveSelectionExam'
                                    {...setValue('haveSelectionExam', OrganizacaoEscola.haveSelectionExam ?? -1)}
                                    register={register('haveSelectionExam')}
                                    value={OrganizacaoEscola.haveSelectionExam ?? -1}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, haveSelectionExam: e.target.value })}>
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.haveSelectionExam?.message}</Message>
                            </Box>
                            <Box style={{ display: Number(OrganizacaoEscola.haveSelectionExam) === 0 ? 'none' : 'block' }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Reserva de vagas por sistema de cotas para grupos específicos de aluno(a)s', 'quotaSystemReservation', Number(OrganizacaoEscola.haveSelectionExam) === 1)}
                                </TitleFieldForm>
                                <Checkbox title='Autodeclarado preto, pardo ou indígena (PPI)'
                                    name='quotaSystemReservation[0]'
                                    setValue={setValue('quotaSystemReservation[0]', OrganizacaoEscola.quotaSystemReservation.ppi)}
                                    register={register('quotaSystemReservation[0]')}
                                    checked={OrganizacaoEscola.quotaSystemReservation.ppi === 1 ? true : false}
                                    disabled={Number(OrganizacaoEscola.haveSelectionExam) === 1 ? false : true}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, quotaSystemReservation: {
                                            ...OrganizacaoEscola.quotaSystemReservation,
                                            ppi: e.target.checked ? 1 : 0,
                                            noneBroadCompetition: 0
                                        }
                                    })} />
                                <Checkbox title='Condições de renda'
                                    name='quotaSystemReservation[1]'
                                    setValue={setValue('quotaSystemReservation[1]', OrganizacaoEscola.quotaSystemReservation.income)}
                                    register={register('quotaSystemReservation[1]')}
                                    checked={OrganizacaoEscola.quotaSystemReservation.income === 1 ? true : false}
                                    disabled={Number(OrganizacaoEscola.haveSelectionExam) === 1 ? false : true}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, quotaSystemReservation: {
                                            ...OrganizacaoEscola.quotaSystemReservation,
                                            income: e.target.checked ? 1 : 0,
                                            noneBroadCompetition: 0
                                        }
                                    })} />
                                <Checkbox title='Oriundo de escola pública'
                                    name='quotaSystemReservation[2]'
                                    setValue={setValue('quotaSystemReservation[2]', OrganizacaoEscola.quotaSystemReservation.publicSchool)}
                                    register={register('quotaSystemReservation[2]')}
                                    checked={OrganizacaoEscola.quotaSystemReservation.publicSchool === 1 ? true : false}
                                    disabled={Number(OrganizacaoEscola.haveSelectionExam) === 1 ? false : true}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, quotaSystemReservation: {
                                            ...OrganizacaoEscola.quotaSystemReservation,
                                            publicSchool: e.target.checked ? 1 : 0,
                                            noneBroadCompetition: 0
                                        }
                                    })} />
                                <Checkbox title='Pessoa com deficiência (PCD)'
                                    name='quotaSystemReservation[3]'
                                    setValue={setValue('quotaSystemReservation[3]', OrganizacaoEscola.quotaSystemReservation.pcd)}
                                    register={register('quotaSystemReservation[3]')}
                                    checked={OrganizacaoEscola.quotaSystemReservation.pcd === 1 ? true : false}
                                    disabled={Number(OrganizacaoEscola.haveSelectionExam) === 1 ? false : true}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, quotaSystemReservation: {
                                            ...OrganizacaoEscola.quotaSystemReservation,
                                            pcd: e.target.checked ? 1 : 0,
                                            noneBroadCompetition: 0
                                        }
                                    })} />
                                <Checkbox title='Outros grupos que não os listados'
                                    name='quotaSystemReservation[4]'
                                    setValue={setValue('quotaSystemReservation[4]', OrganizacaoEscola.quotaSystemReservation.otherGroupsNoListed)}
                                    register={register('quotaSystemReservation[4]')}
                                    checked={OrganizacaoEscola.quotaSystemReservation.otherGroupsNoListed === 1 ? true : false}
                                    disabled={Number(OrganizacaoEscola.haveSelectionExam) === 1 ? false : true}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, quotaSystemReservation: {
                                            ...OrganizacaoEscola.quotaSystemReservation,
                                            otherGroupsNoListed: e.target.checked ? 1 : 0,
                                            noneBroadCompetition: 0
                                        }
                                    })} />
                                <Checkbox title='Sem reservas de vagas para sistema de cotas (ampla concorrência)'
                                    name='quotaSystemReservation[5]'
                                    setValue={setValue('quotaSystemReservation[5]', OrganizacaoEscola.quotaSystemReservation.noneBroadCompetition)}
                                    register={register('quotaSystemReservation[5]')}
                                    checked={OrganizacaoEscola.quotaSystemReservation.noneBroadCompetition === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, quotaSystemReservation:
                                            IsNone(OrganizacaoEscola.quotaSystemReservation, 'noneBroadCompetition'),

                                    })} />
                                <Message>{errors.quotaSystemReservation?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('A escola possui site ou blog ou página em redes socias para comunicação Institucional', 'haveSite')}
                                </TitleFieldForm>
                                <Select
                                    name='haveSite'

                                    // {...setValue('haveDrinkingWater', CaracterizacaoEscola.haveDrinkingWater ?? 0)}
                                    value={!OrganizacaoEscola.haveSite?.length || 0 ? "" : OrganizacaoEscola.haveSite}
                                    register={register('haveSite')}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, haveSite: e.target.value })}>

                                    <Option value={100} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                            </Box>
                            <Box>
                                <TitleFieldForm>
                                    {getTitleIndex('A escola compartilha espaços para atividades para integração escola-comunidade','shareSpaceIntegrationCommunity')}
                                </TitleFieldForm>
                                <Select

                                    name="shareSpaceIntegrationCommunity"
                                    value={!OrganizacaoEscola.shareSpaceIntegrationCommunity === null ? "" : OrganizacaoEscola.shareSpaceIntegrationCommunity}
                                    register={register("shareSpaceIntegrationCommunity")}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, shareSpaceIntegrationCommunity: e.target.value })}>
                                    <Option value={''} defaultValue disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.shareSpaceIntegrationCommunity?.message}</Message>
                            </Box>
                            <Box>
                                <TitleFieldForm>
                                    {getTitleIndex('A escola usa espaços e equipamentos do entorno escolar para atividades regulares com os alunos', 'useSurroundingSpacesEquipment')}
                                </TitleFieldForm>
                                <Select

                                    name="useSurroundingSpacesEquipment"
                                    // {...setValue('haveDrinkingWater', CaracterizacaoEscola.haveDrinkingWater ?? 0)}
                                    register={register("useSurroundingSpacesEquipment")}
                                    value={!OrganizacaoEscola.useSurroundingSpacesEquipment?.length || 0 ? "" : OrganizacaoEscola.useSurroundingSpacesEquipment}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, useSurroundingSpacesEquipment: e.target.value })}>
                                    <Option value={100} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.useSurroundingSpacesEquipment?.message}</Message>
                            </Box>
                            <Box>
                                <TitleFieldForm>
                                {getTitleIndex('Órgãos colegiados em funcionamento na escola', 'collegiateBodies')}<Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Checkbox title='Associação de pais'
                                    name="collegiateBodies[0]"
                                    setValue={setValue('collegiateBodies[0]', OrganizacaoEscola.collegiateBodies.parentsAssociation)}
                                    register={register("collegiateBodies[0]")}
                                    checked={OrganizacaoEscola.collegiateBodies.parentsAssociation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, collegiateBodies: {
                                            ...OrganizacaoEscola.collegiateBodies,
                                            parentsAssociation: e.target.checked ? 1 : 0,
                                            noneCB: 0
                                        }
                                    })} />
                                <Checkbox title='Associação de pais e mestres'
                                    name="collegiateBodies[1]"
                                    setValue={setValue('collegiateBodies[1]', OrganizacaoEscola.collegiateBodies.parentsTeacherAssociation)}
                                    register={register("collegiateBodies[1]")}
                                    checked={OrganizacaoEscola.collegiateBodies.parentsTeacherAssociation === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, collegiateBodies: {
                                            ...OrganizacaoEscola.collegiateBodies,
                                            parentsTeacherAssociation: e.target.checked ? 1 : 0,
                                            noneCB: 0
                                        }
                                    })} />
                                <Checkbox title='Conselhos escolar'
                                    name="collegiateBodies[2]"
                                    setValue={setValue('collegiateBodies[2]', OrganizacaoEscola.collegiateBodies.schoolCouncil)}
                                    register={register("collegiateBodies[2]")}
                                    checked={OrganizacaoEscola.collegiateBodies.schoolCouncil === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, collegiateBodies: {
                                            ...OrganizacaoEscola.collegiateBodies,
                                            schoolCouncil: e.target.checked ? 1 : 0,
                                            noneCB: 0
                                        }
                                    })} />
                                <Checkbox title='Grêmio estudantil'
                                    name="collegiateBodies[3]"
                                    setValue={setValue('collegiateBodies[3]', OrganizacaoEscola.collegiateBodies.studentCouncil)}
                                    register={register("collegiateBodies[3]")}
                                    checked={OrganizacaoEscola.collegiateBodies.studentCouncil === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, collegiateBodies: {
                                            ...OrganizacaoEscola.collegiateBodies,
                                            studentCouncil: e.target.checked ? 1 : 0,
                                            noneCB: 0
                                        }
                                    })} />
                                <Checkbox title='Outros'
                                    name="collegiateBodies[4]"
                                    setValue={setValue('collegiateBodies[4]', OrganizacaoEscola.collegiateBodies.others)}
                                    register={register("collegiateBodies[4]")}
                                    checked={OrganizacaoEscola.collegiateBodies.others === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, collegiateBodies: {
                                            ...OrganizacaoEscola.collegiateBodies,
                                            others: e.target.checked ? 1 : 0,
                                            noneCB: 0
                                        }
                                    })} />
                                <Checkbox title='Não há órgãos colegiados em funcionamento'
                                    name="collegiateBodies[5]"
                                    setValue={setValue('collegiateBodies[5]', OrganizacaoEscola.collegiateBodies.noneCB)}
                                    register={register("collegiateBodies[5]")}
                                    checked={OrganizacaoEscola.collegiateBodies.noneCB === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, collegiateBodies:
                                            IsNone(OrganizacaoEscola.collegiateBodies, 'noneCB')

                                    })} />
                                <Message>{errors.collegiateBodies?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('O projeto politico pedagógico ou a proposta pedagófica da escola(conforme art. 12 da LDB) foi atualizada nos últimos 12 meses até a data de referência','pedagogicalProjectProposal')}
                                </TitleFieldForm>
                                <Select

                                    name="pedagogicalProjectProposal"
                                    register={register("pedagogicalProjectProposal")}
                                    // {...setValue('haveDrinkingWater', CaracterizacaoEscola.haveDrinkingWater ?? 0)}
                                    value={OrganizacaoEscola.pedagogicalProjectProposal}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, pedagogicalProjectProposal: e.target.value })}>
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                    <Option value={2}>A escola não possui projeto político pedagógico/proposta pedagógica</Option>
                                </Select>
                                <Message>{errors.pedagogicalProjectProposal?.message}</Message>
                            </Box>
                            <Box style={{ marginTop: 10 }}>
                                <TitleFieldForm>
                                    {getTitleIndex('A escola desenvolve ações na área de educação ambiental?','hasDevelopmentEnvironmentalEducation')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Select
                                    {...setValue('hasDevelopmentEnvironmentalEducation', OrganizacaoEscola.hasDevelopmentEnvironmentalEducation ?? -1)}
                                    name='hasDevelopmentEnvironmentalEducation'
                                    {...register('hasDevelopmentEnvironmentalEducation')}
                                    value={OrganizacaoEscola.hasDevelopmentEnvironmentalEducation ?? -1}
                                    onChange={(e) => setOrganizacaoEscola({ ...OrganizacaoEscola, hasDevelopmentEnvironmentalEducation: Number(e.target.value) })}>
                                    <Option value={-1} disabled hidden>selecione</Option>
                                    <Option value={0}>Não</Option>
                                    <Option value={1}>Sim</Option>
                                </Select>
                                <Message>{errors.hasDevelopmentEnvironmentalEducation?.message}</Message>
                            </Box>
                            <Box style={{ display: OrganizacaoEscola.hasDevelopmentEnvironmentalEducation === 1 ? 'block' : 'none' }}>
                                <TitleFieldForm>
                                    {getTitleIndex('Informe de qual(quais) forma(s) a educação ambiental é desenvolvida na escola:','formsEnvironmentalEducation', OrganizacaoEscola.hasDevelopmentEnvironmentalEducation === 1)}
                                </TitleFieldForm>
                                <Checkbox id='formsEnvironmentalEducation[0]' title='Como conteúdo dos componentes/campos de experiências presentes no currículo'
                                    name='formsEnvironmentalEducation[0]'
                                    setValue={setValue('formsEnvironmentalEducation[0]', OrganizacaoEscola.formsEnvironmentalEducation.experienceFields) === 1 ? 1 : 0}
                                    register={register('formsEnvironmentalEducation[0]')}
                                    disabled={Number(OrganizacaoEscola.hasDevelopmentEnvironmentalEducation) === 1 ? false : true}
                                    checked={OrganizacaoEscola.formsEnvironmentalEducation.experienceFields === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, formsEnvironmentalEducation: {
                                            ...OrganizacaoEscola.formsEnvironmentalEducation,
                                            experienceFields: e.target.checked ? 1 : 0,
                                            noneFEE: 0,
                                        }
                                    })} />
                                <Checkbox id='formsEnvironmentalEducation[1]' title='Como um componente curricular especial, específico, flexível ou eletivo'
                                    name='formsEnvironmentalEducation[1]'
                                    setValue={setValue('formsEnvironmentalEducation[1]', OrganizacaoEscola.formsEnvironmentalEducation.specialCurricularComponent) === 1 ? 1 : 0}
                                    register={register('formsEnvironmentalEducation[1]')}
                                    disabled={Number(OrganizacaoEscola.hasDevelopmentEnvironmentalEducation) === 1 ? false : true}
                                    checked={OrganizacaoEscola.formsEnvironmentalEducation.specialCurricularComponent === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, formsEnvironmentalEducation: {
                                            ...OrganizacaoEscola.formsEnvironmentalEducation,
                                            specialCurricularComponent: e.target.checked ? 1 : 0,
                                            noneFEE: 0,
                                        }
                                    })} />
                                <Checkbox id='formsEnvironmentalEducation[2]' title='Como um eixo estruturante do currículo'
                                    name='formsEnvironmentalEducation[2]'
                                    setValue={setValue('formsEnvironmentalEducation[2]', OrganizacaoEscola.formsEnvironmentalEducation.curriculumAxis) === 1 ? 1 : 0}
                                    register={register('formsEnvironmentalEducation[2]')}
                                    disabled={Number(OrganizacaoEscola.hasDevelopmentEnvironmentalEducation) === 1 ? false : true}
                                    checked={OrganizacaoEscola.formsEnvironmentalEducation.curriculumAxis === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, formsEnvironmentalEducation: {
                                            ...OrganizacaoEscola.formsEnvironmentalEducation,
                                            curriculumAxis: e.target.checked ? 1 : 0,
                                            noneFEE: 0,
                                        }
                                    })} />
                                <Checkbox id='formsEnvironmentalEducation[3]' title='Em eventos'
                                    name='formsEnvironmentalEducation[3]'
                                    setValue={setValue('formsEnvironmentalEducation[3]', OrganizacaoEscola.formsEnvironmentalEducation.inEvents) === 1 ? 1 : 0}
                                    register={register('formsEnvironmentalEducation[3]')}
                                    disabled={Number(OrganizacaoEscola.hasDevelopmentEnvironmentalEducation) === 1 ? false : true}
                                    checked={OrganizacaoEscola.formsEnvironmentalEducation.inEvents === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, formsEnvironmentalEducation: {
                                            ...OrganizacaoEscola.formsEnvironmentalEducation,
                                            inEvents: e.target.checked ? 1 : 0,
                                            noneFEE: 0,
                                        }
                                    })} />
                                <Checkbox id='formsEnvironmentalEducation[4]' title='Em projetos transversais ou interdisciplinares'
                                    name='formsEnvironmentalEducation[4]'
                                    setValue={setValue('formsEnvironmentalEducation[4]', OrganizacaoEscola.formsEnvironmentalEducation.interdisciplinaryProjectsFEE) === 1 ? 1 : 0}
                                    register={register('formsEnvironmentalEducation[4]')}
                                    disabled={Number(OrganizacaoEscola.hasDevelopmentEnvironmentalEducation) === 1 ? false : true}
                                    checked={OrganizacaoEscola.formsEnvironmentalEducation.interdisciplinaryProjectsFEE === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, formsEnvironmentalEducation: {
                                            ...OrganizacaoEscola.formsEnvironmentalEducation,
                                            inEvinterdisciplinaryProjectsFEEents: e.target.checked ? 1 : 0,
                                            noneFEE: 0,
                                        }
                                    })} />
                                <Checkbox id='formsEnvironmentalEducation[5]' title='Nenhuma das opções listadas'
                                    name='formsEnvironmentalEducation[5]'
                                    setValue={setValue('formsEnvironmentalEducation[5]', OrganizacaoEscola.formsEnvironmentalEducation.noneFEE) === 1 ? 1 : 0}
                                    register={register('formsEnvironmentalEducation[5]')}
                                    disabled={Number(OrganizacaoEscola.hasDevelopmentEnvironmentalEducation) === 1 ? false : true}
                                    checked={OrganizacaoEscola.formsEnvironmentalEducation.noneFEE === 1 ? true : false}
                                    onChange={(e) => setOrganizacaoEscola({
                                        ...OrganizacaoEscola, formsEnvironmentalEducation:
                                            IsNone(OrganizacaoEscola.formsEnvironmentalEducation, 'noneFEE')

                                    })} />
                                <Message>{errors.formsEnvironmentalEducation?.message}</Message>
                            </Box>

                            <ButtonFormFooter
                                textNext="Salvar"
                                linkBack={"/escola/editar-caracterizacao"}
                            />
                        </FormContent>
                    </form>
                </Container>
            </App>
        </>
    )

}
export default Organizacao;